import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardAppSharedService,
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto,
} from '../../services/wealthlane-award-services';

const useGetParticipantDashboardTask = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto[] | undefined,
  unknown
> => {
  const participantDashboardTask = useQuery(
    ['getParticipantDashboardTask'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        DashboardAppSharedService.getApiAwardApiAppDashboardParticipantTask()
      );
    }
    // }
  );
  return participantDashboardTask;
};

export default useGetParticipantDashboardTask;
